var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84449 15.0399H5.86841C6.42816 15.0399 6.88038 14.5905 6.88038 14.0343C6.88038 13.478 6.42816 13.0286 5.86841 13.0286H3.84449C3.28569 13.0286 2.83252 12.5782 2.83252 12.0229V3.97748C2.83252 3.42216 3.28569 2.97181 3.84449 2.97181H5.86841C6.42816 2.97181 6.88038 2.52145 6.88038 1.96613C6.88038 1.4108 6.42816 0.960449 5.86841 0.960449H3.84449C2.16779 0.960449 0.808594 2.3112 0.808594 3.97748V12.0229C0.808594 13.6886 2.16779 15.0399 3.84449 15.0399ZM16.7723 7.45022L12.2153 3.17608C11.9947 2.96935 11.6714 2.91288 11.3931 3.03171C11.1147 3.15104 10.9342 3.42361 10.9342 3.72468L10.9313 5.98746L6.88348 5.98743C6.32406 5.98743 5.87089 6.43778 5.87089 6.9931V9.00446C5.87089 9.55978 6.32437 10.0101 6.88348 10.0101L10.9313 10.0102L10.9342 12.2447C10.9342 12.5457 11.1147 12.8182 11.3931 12.9376C11.6715 13.0565 11.9949 13 12.2153 12.7933L16.7723 8.51913C17.0759 8.26419 17.0759 7.73621 16.7723 7.45022Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.82bad53f7dfd85640e51434d2d3bb9d3.svg";
export { ForwardRef as ReactComponent };